import type { DataTableColumn } from '@/components/custom/erp';
import type { NgoaiTe } from '@/types/schemas';

export const currencyColumns: DataTableColumn<NgoaiTe>[] = [
  { field: 'ma_nt', headerName: 'Ngoại tệ', width: 160 },
  { field: 'ten_nt', headerName: 'Tên ngoại tệ', width: 260, flex: 1 }
];
